"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Input = _interopRequireDefault(require("./Input"));

var _NumberInput = _interopRequireDefault(require("./NumberInput"));

var _react = _interopRequireDefault(require("react"));

var _withFork = _interopRequireDefault(require("./Input/withFork"));

var _withFork2 = _interopRequireDefault(require("./NumberInput/withFork"));

var _withFork3 = _interopRequireDefault(require("./CardInput/withFork"));

var _CardInput = _interopRequireDefault(require("./CardInput"));

var _SearchInput = _interopRequireDefault(require("./SearchInput"));

var _withFork4 = _interopRequireDefault(require("./SearchInput/withFork"));

var _DateInput = _interopRequireDefault(require("./DateInput"));

var _CvvInput = _interopRequireDefault(require("./CvvInput"));

var _withFork5 = _interopRequireDefault(require("./CvvInput/withFork"));

var _withFork6 = _interopRequireDefault(require("./Button/withFork"));

var _withFork7 = _interopRequireDefault(require("./Interval/withFork"));

var _Button = _interopRequireDefault(require("./Button"));

var _Interval = _interopRequireDefault(require("./Interval"));

var _Table = require("./Table");

var _withFork8 = require("./Table/withFork");

var getComponent = function getComponent(C) {
  if (C === _Input["default"]) {
    return _withFork["default"];
  } else if (C === _NumberInput["default"]) {
    return _withFork2["default"];
  } else if (C === _CardInput["default"]) {
    return _withFork3["default"];
  } else if (C === _SearchInput["default"]) {
    return _withFork4["default"];
  } else if (C === _DateInput["default"]) {
    return _withFork4["default"];
  } else if (C === _CvvInput["default"]) {
    return _withFork5["default"];
  } else if (C === _Button["default"]) {
    return _withFork6["default"];
  } else if (C === _Interval["default"]) {
    return _withFork7["default"];
  } else if (C === _Table.Table) {
    return _withFork8.table;
  } else if (C === _Table.Tbh) {
    return _withFork8.tbh;
  } else if (C === _Table.Tbody) {
    return _withFork8.tbody;
  } else if (C === _Table.Td) {
    return _withFork8.td;
  } else if (C === _Table.Tfoot) {
    return _withFork8.tfoot;
  } else if (C === _Table.Th) {
    return _withFork8.th;
  } else if (C === _Table.Thead) {
    return _withFork8.thead;
  } else if (C === _Table.Tr) {
    return _withFork8.tr;
  } else {
    return null;
  }
};

var fork = function fork(Component, themeOverride) {
  var hoc = getComponent(Component);

  if (hoc) {
    return hoc(themeOverride);
  } else {
    return Component;
  }
};

var _default = fork;
exports["default"] = _default;